import type { BaseEntity } from './BaseEntity';

export interface ProductBulkPricingMarkupLineItem extends BaseEntity {
  productId: number;
  pounds: number;
  markup: number;
}

export interface ProductHistoricalBulkPricingMarkupLineItem extends ProductBulkPricingMarkupLineItem {

}

type ValidationResult = { issues: { message: string; path: (keyof ProductBulkPricingMarkupLineItem)[] }[] };

export function validate(bulkPricingMarkupLineItem: Partial<ProductBulkPricingMarkupLineItem>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!bulkPricingMarkupLineItem.productId) {
    issues = [...issues, { message: 'Product is required', path: ['productId'] }];
  }

  if (!bulkPricingMarkupLineItem.pounds) {
    issues = [...issues, { message: 'Pounds is required', path: ['pounds'] }];
  }

  if (!bulkPricingMarkupLineItem.markup) {
    issues = [...issues, { message: 'Markup is required', path: ['markup'] }];
  }

  return { issues };
}